import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { normalizeLanguage } from "../../services/language";
import ModernSidebar, { useModernRouteActions } from "../lobby/ModernSidebar";
import "../lobby/lobbyModern.css";
import "../../pages/user/learnV2.css";

// Marco común de Aprender (portada, guías y libros): menú lateral del diseño Clásico dentro del
// juego; en la versión pública (/aprender, sin sesión) no hay menú lateral.
const SidebarFrame = ({ children }) => {
  const outletContext = useOutletContext() || {};
  const routeActions = useModernRouteActions();
  const language = normalizeLanguage(outletContext.language || "es");
  useEffect(() => {
    document.body.classList.add("xima-lobby-modern-active", "xle-page-active");
    return () => document.body.classList.remove("xima-lobby-modern-active", "xle-page-active");
  }, []);
  return (
    <div className="xlm-root xle-root">
      <ModernSidebar
        language={language}
        active="learn"
        badges={outletContext.sidebarBadges || {}}
        isAdmin={Boolean(outletContext.hasAdminMenuAccess)}
        actions={routeActions}
      />
      <div className="xlm-main xle-main">
        <div className="xle-shell">{children}</div>
      </div>
    </div>
  );
};

const LearnShell = ({ publicMode = false, children }) => {
  if (publicMode) {
    return (
      <div className="xle-root is-public">
        <div className="xle-main">
          <div className="xle-shell">{children}</div>
        </div>
      </div>
    );
  }
  return <SidebarFrame>{children}</SidebarFrame>;
};

export default LearnShell;
